/**
 * Pure helpers for the keep-vote and the lock (#946, slice 4).
 */

/** What a solution's card warns about, from the AI's reading of the pairs. */
const WARNING_ORDER = ['conflict', 'overlap', 'competing', 'needs', 'enables'];

export function warningsFor(solutionId, edges = []) {
  const out = [];
  for (const e of edges) {
    if (e.a !== solutionId && e.b !== solutionId) continue;
    const other = e.a === solutionId ? e.b : e.a;
    if (e.relation === 'enables') out.push({ kind: e.from === solutionId ? 'enables' : 'needs', other, edge: e });
    else if (['conflict', 'overlap', 'competing'].includes(e.relation)) out.push({ kind: e.relation, other, edge: e });
  }
  return out.sort((x, y) => WARNING_ORDER.indexOf(x.kind) - WARNING_ORDER.indexOf(y.kind));
}

/**
 * Same rule as the server's lockRules.followsVote: every chosen solution has
 * at least as many votes as every one left out. Shown live in the lock panel so
 * the facilitator knows before pressing the button whether a reason is needed.
 */
export function followsVote(chosenIds, counts, allIds) {
  if (!chosenIds.length) return true;
  const chosen = new Set(chosenIds);
  const n = (id) => counts[id] || 0;
  const minChosen = Math.min(...chosenIds.map(n));
  const left = allIds.filter((id) => !chosen.has(id));
  return !left.length || minChosen >= Math.max(...left.map(n));
}

/** The default selection: the top half by votes, with everything tied at the cut-off. */
export function defaultSelection(solutions, counts) {
  const ranked = [...solutions].sort((a, b) => (counts[b.id] || 0) - (counts[a.id] || 0));
  const half = Math.ceil(ranked.length / 2);
  if (!ranked.length || !Object.keys(counts).length) return [];
  const cut = counts[ranked[half - 1].id] || 0;
  return ranked.filter((s, i) => i < half || (counts[s.id] || 0) === cut).filter((s) => (counts[s.id] || 0) > 0).map((s) => s.id);
}
